import { createMachine } from 'xstate';
import { assign } from '@xstate/immer';
import * as MyUpdates from './myUpdates.types';

export const myUpdatesSM = createMachine(
  {
    id: 'MyUpdatesSM',
    tsTypes: {} as import('./myUpdates.machine.typegen').Typegen0,
    predictableActionArguments: true,
    preserveActionOrder: true,
    schema: {
      context: {} as MyUpdates.SMContext,
      events: {} as MyUpdates.SMEvents,
      services: {} as MyUpdates.SMServices,
    },
    context: {
      allExpanded: false,
    },
    initial: 'preparingMachine',
    states: {
      preparingMachine: {
        after: {
          0: {
            target: 'ready',
          },
        },
      },
      ready: {
        on: {
          TOGGLE_ALL_EXPANDED_STATE: {
            actions: 'toggleAllExpandedState',
          },
        },
      },
    },
  },
  {
    guards: {},
    actions: {
      toggleAllExpandedState: assign((ctx) => {
        ctx.allExpanded = !ctx.allExpanded;
      }),
    },
    services: {},
  },
)

export default myUpdatesSM
